import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet<{ ids: string[] }>('competitions.files');

export function useCompetitionFileListQuery(params: { ids: string[] }) {
  return useQuery({
    queryFn: async () => {
      const responses = await Promise.all(params.ids.map(id => SSF.api.competitionFilesRetrieve(id)));
      return responses.map(resp => resp.data);
    },
    enabled: params.ids.length > 0,
    queryKey: keys.list(params),
  });
}
